import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResidualsService } from 'app/layout/residuals/residuals.service';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { SalesEntityModelList, SalesEntityListInquiry, SalesEntityModel } from 'app/shared/models/EvoSalesPortalModel';

@Component({
	selector: 'se-selector-modal',
	styleUrls: ['./se-selector-modal.scss'],
	templateUrl: 'se-selector-content.component.html',
})
export class SalesEntitySelectorModalComponent {
	seBindingContext: BindingContext = new BindingContext();
	public salesEntityTreeModel: SalesEntityModelList = new SalesEntityModelList();
	public salesEntityID: number;
	private retvalSE: SalesEntityModel;
	hasChildren: boolean;

	constructor(public activeModal: NgbActiveModal,
		private rSvc: ResidualsService,
		private seSvc: SalesEntityService) {
		this.seBindingContext.isBusy = false;
		this.InitialSE_Get();
	}

	ngOnInit() {

	}

	goToBreadcrumb(crumb: any) {
		console.log('breadcrumb clicked', crumb);
		this.SalesEntityChanged(crumb.id);
	}
	// Event when dropdown is selected
	SalesEntityChanged(seID: number) {
		this.seBindingContext.beginGet();
		this.seBindingContext.isBusy = true;
		if(seID === null || seID === undefined)
		{
			seID = 0;
		}
		this.GetSalesEntities(seID);
		this.salesEntityID = seID;
	}

	// Called from the constructor for the first load
	InitialSE_Get() {
		this.seBindingContext.beginGet();		
		const promise = this.seSvc.getSalesEntitiesForSelect(0).toPromise().then(resp => {
			// console.log("initial SE Get: ", resp);
			// If we came back via a breadcrumb to this page and we have a defined selected entity
			// Set up the page based on that entity (when they change it it'll change in the svc)
			this.salesEntityTreeModel = resp;
			if (this.salesEntityTreeModel.SalesEntities.length === 1 && this.salesEntityTreeModel.SalesEntities[0].ChildCount < 1) {
				// If there's only one SE with no children then load up everything automatically.
				this.hasChildren = false;
				this.salesEntityID = this.salesEntityTreeModel.SalesEntities[0].SalesEntityID;
				// this.salesEntityName = this.salesEntityTreeModel.SalesEntities[0].Name;
			} else {
				this.hasChildren = true;
			}
			this.seBindingContext.endGet();
		}).catch(err => {
			// problem getting entities
			console.log(err);
			this.seBindingContext.endGet();
			this.seBindingContext.alertMessage = 'Error retrieving sales entities.';
			this.seBindingContext.alertType = BindingContext.alertType.danger;
		});
	}// End InitialSE_Get

	public selectEntity() {
		this.retvalSE = new SalesEntityModel();
		this.retvalSE.Name = this.salesEntityTreeModel.BreadCrumbs[0].CurrentName;
		this.retvalSE.SalesEntityID = this.salesEntityID;
		this.activeModal.close(this.retvalSE);
	}

	// Get the list of sales entities and update the public model bound to the dropdown
	// Called from every subsequent change/load
	GetSalesEntities(parentEntityID: number) {		
		if (parentEntityID === null) {
			parentEntityID = 0;
		}
		const promise = this.seSvc.getSalesEntitiesForSelect(parentEntityID).toPromise().then(resp => {
			console.log(resp);
			this.salesEntityTreeModel = resp;
			const hasData = (resp.SalesEntities.length > 0);
			this.seBindingContext.endGet(hasData);
			this.hasChildren = hasData;
			this.seBindingContext.isBusy = false;
		}).catch(err => {
			// problem getting entities
			console.log(err);
			this.seBindingContext.endGet();
			this.seBindingContext.isBusy = false;
			this.seBindingContext.alertMessage = 'Error retrieving sales entities.';
			this.seBindingContext.alertType = BindingContext.alertType.danger;
		});
	}// End GetSalesEntities
}
